import { useQuery } from "@apollo/client/react";import React, { useState, useMemo, useEffect } from "react";

import { Box, CircularProgress, Grid } from "@mui/material";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { HeaderChip } from "../components/TabDatosCalificacion/HeaderChip";

const CLASE_A = 1;
const CLASE_B = 2;
const CLASE_C = 3;

export const TabDatosCalificacion = ({
  allowedWrite,
  isNew,
  profesionalLoading,
  monitoreoFormData,
  setMonitoreoFormData,
  calificacionesMonitoreo
}) => {
  const handleChange = (name, value) => {
    setMonitoreoFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const updatedFields = useMemo(() => {
    return structuredClone(fields).
    map((input) => {
      const updatedInput = { ...input };
      switch (input.name) {
        default:
          break;
      }
      if (!allowedWrite) {
        updatedInput.disabled = true;
      }
      return updatedInput;
    });
  }, [
  monitoreoFormData]
  );

  useEffect(() => {
    let puntos = 0;
    let calificacion = 1;
    if (!!monitoreoFormData?.posgradoEspecifico)
    puntos += 2;
    if (!!monitoreoFormData?.experienciaEspecifica)
    puntos += 3;
    if (!!monitoreoFormData?.profesionalZona)
    puntos += 2;



    if (puntos >= 4)
    calificacion = CLASE_A;else
    if (puntos >= 2)
    calificacion = CLASE_B;else

    calificacion = CLASE_C;

    setMonitoreoFormData((prevData) => ({
      ...prevData,
      puntosClasificacion: puntos,
      idCalificacionMonitoreo: calificacion
    }));
  }, [monitoreoFormData.posgradoEspecifico,
  monitoreoFormData.experienciaEspecifica,
  monitoreoFormData.profesionalZona]);

  const loadingPage = useMemo(() => {
    return profesionalLoading;
  }, [profesionalLoading]);

  if (loadingPage) return <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '20vh'
    }}>
    
        <CircularProgress size={40} />
    </Box>;

  return (
    <div className='generic-tab-container'>
            <Grid container spacing={3}>
                {updatedFields.
        map((input, index) =>
        <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== 'item' ? 12 : 0 }}>
                            {input.name !== 'puntos' &&
          <RenderInputByTypeMobile
            key={`input-${input.name}-index-${index}`}
            input={input}
            handleChange={handleChange}
            value={monitoreoFormData[input.name]} />
          }
                            {
          input.name === 'puntos' &&
          <HeaderChip
            puntaje={monitoreoFormData?.puntosClasificacion}
            claseMonitoreo={calificacionesMonitoreo.find((x) => x.id == monitoreoFormData?.idCalificacionMonitoreo)?.displayName} />

          }
                        </Grid>
        )
        }
            </Grid>
        </div>);

};

const fields = [
{
  displayName: 'Puntos',
  name: 'puntos',
  type: 'puntos',
  disabled: false,
  col: 12
},
{
  displayName: 'Posgrado Especifico',
  name: 'posgradoEspecifico',
  type: 'boolean',
  disabled: false,
  col: 12
},
{
  displayName: 'Datos',
  name: 'observacionPosgradoEspecifico',
  type: 'long_string',
  disabled: false,
  required: true,
  col: 12
},
{
  displayName: 'Experiencia Especifica',
  name: 'experienciaEspecifica',
  type: 'boolean',
  disabled: false,
  col: 12
},
{
  displayName: 'Datos',
  name: 'observacionExperienciaEspecifica',
  type: 'long_string',
  required: true,
  col: 12
},
{
  displayName: 'Profesional de Zona',
  name: 'profesionalZona',
  type: 'boolean',
  disabled: false,
  col: 12
},
{
  displayName: 'Datos',
  name: 'observacionProfesionalZona',
  type: 'long_string',
  disabled: false,
  required: true,
  col: 12
}];